<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Chuyên cần" :link="[{ text: 'Chuyên cần', href: '../attendances' }]" />
      </div>
    </div>
    <v-tabs class="mx-md-4" v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab v-for="item in getTabs" :key="item" class="tab-default">
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-card outlined class="mx-md-4 elevation-0">
      <v-tabs-items v-model="tab" v-if="getTabs.length > 0">
        <v-tab-item v-if="getTabs.includes('Điểm danh')" :key="1">
          <Attendances />
        </v-tab-item>
        <v-tab-item v-if="getTabs.includes('Chuyên cần')" :key="2">
          <Diligences />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import Attendances from '@/views/attendance/Attendances.vue'
import Diligences from '@/views/diligence/Diligences'

export default {
  components: {
    Breadcrumbs,
    Attendances,
    Diligences
  },
  data() {
    return {
      tab: null
    }
  },
  computed: {
    getTabs() {
      const tabs = []
      if (this.$auth.policies['view-attendance-list']) {
        tabs.push('Điểm danh')
      }
      if (this.$auth.policies['view-diligence-list']) {
        tabs.push('Chuyên cần')
      }
      return tabs
    }
  }
}
</script>
